import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { Storages } from "./Storages";
import { Item } from "../Form/Item";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { components } from "react-select";
import { Pagination } from "../../../Components/Pagination";

export const GrantingPermission = ({
  onChange = () => {},
  value = [],
  privilegeGroupsValue = [],
  handleUpdate,
  isAdd,
  cb,
  tempUserInfor,
  userInfo,
  setSelectedValues,
  selectedValues,
}) => {
  const [storages, setStorages] = useState(selectedValues?.storages || []);
  const findPlants =
    selectedValues?.storages && selectedValues.storages.length > 0
      ? [...new Set(selectedValues.storages.map((item) => item?.["7MKV"]))]
      : [];

  const [area, setArea] = useState(findPlants);

  const [currentPage, setCurrentPage] = useState(1);
  const dataPerPage = 5;
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const [search, setSearch] = useState({});
  const uniqueStorages = [];
  const seen = new Set();

  selectedValues &&
    selectedValues.storages.length &&
    (selectedValues?.searchStorages
      ? selectedValues?.searchStorages
      : selectedValues?.storages
    )?.forEach((item) => {
      // if (!seen.has(item?.maKhoERPKho)) {
      uniqueStorages.push(item);
      // seen.add(item?.maKhoERPKho);
      // }
    });

  const currentData =
    uniqueStorages &&
    uniqueStorages.length &&
    uniqueStorages.slice(indexOfFirstData, indexOfLastData);

  const { proxy, lang } = useSelector((s) => s);

  const [views, setViews] = useState(
    selectedValues?.storages && selectedValues?.storages?.length
      ? selectedValues?.storages
      : [],
  );

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    // setSearch((prev) => ({
    //   ...prev,
    //   page: pageNumber,
    //   limit: dataPerPage,
    // }));
  };
  const [privilegeGroups, setPrivilegeGroups] = useState([]);
  const _token = localStorage.getItem("_token");
  const debounceTimeout = useRef();
  const location = useLocation();
  const [isModalConfirm, setModalConfirm] = useState(false);
  const navigate = useNavigate();
  const [dataArea, setDataArea] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await fetch(`${proxy()}/privileges/groups`, {
        headers: { authorization: _token },
      });
      const result = await response.json();
      setPrivilegeGroups(
        result?.groups?.map(({ privilegegroup_id, group_name }) => ({
          label: group_name,
          value: privilegegroup_id,
        })) || [],
      );
    })();
  }, []);

  useEffect(() => {
    onChange(storages);
    // setViews(storages);
  }, [storages]);

  const handleGetData = async (page = 0, loadedOptions, search = "") => {
    try {
      const response = await fetch(
        `${proxy()}/area/get?skip=${page}&search=${search}`,
        {
          method: "POST",
          headers: {
            "content-type": "application/json",
            Authorization: localStorage.getItem("_token"),
          },
        },
      );
      const result = await response.json();

      let newData = {
        options: [],
        hasMore: false,
        additional: {
          page: 0,
        },
      };
      if (result.length) {
        newData.additional = { page: page + 15 };
        newData.hasMore = result.length ? true : false;
        newData.options = result.map((area) => ({
          ...area,
          label: area["2TKV"],
          value: area["7MKV"],
        }));
        setDataArea(newData?.options);
      }
      return newData;
    } catch (err) {
      console.log("OPTION ERROR:", err);
    }
  };

  const handleDelete = (id) => {
    setStorages((prev) => prev.filter((item) => id !== item?.maKhoERPKho));
    // setViews((prev) => prev.filter((item) => id !== item?.device_name));

    setSelectedValues((prev) => {
      const newPrev = { ...prev };
      const storages = newPrev.storages.filter((l) => id !== l.maKhoERPKho);
      const searchStorages = newPrev.searchStorages.filter(
        (l) => id !== l.maKhoERPKho,
      );

      return {
        ...newPrev,
        storages,
        searchStorages,
      };
    });
  };
  // const handleSearch = (value, alias) => {
  //   if (debounceTimeout.current) {
  //     clearTimeout(debounceTimeout.current);
  //   }

  //   const search = {
  //     [alias]: value.trim(),
  //   };

  //   const queryString = new URLSearchParams(search).toString();

  //   debounceTimeout.current = setTimeout(async () => {
  //     const response = await fetch(`${proxy()}/area/warehouse?${queryString}`, {
  //       method: "POST",
  //       headers: {
  //         "content-type": "application/json",
  //         Authorization: localStorage.getItem("_token"),
  //       },
  //       body: JSON.stringify({ search, areaId: area }),
  //     });
  //     const result = await response.json();

  //     if (!value.trim()) {
  //       setSelectedValues((prev) => ({
  //         ...prev,
  //         storages: views,
  //       }));
  //       return;
  //     }

  //     setSelectedValues((prev) => {
  //       const prevDeviceNames =
  //         (prev?.storages &&
  //           prev?.storages?.length &&
  //           prev?.storages?.map((item) => item.maKhoERPKho)) ||
  //         [];

  //       const filteredResult =
  //         result &&
  //         result.length &&
  //         result.filter((item) => prevDeviceNames?.includes(item.maKhoERPKho));
  //       return {
  //         ...prev,
  //         storages: filteredResult,
  //       };
  //     });
  //   }, 300);
  // };

  useEffect(() => {
    if (Object.values(search).length) {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      // const search = {
      //   [alias]: value.trim(),
      // };

      const queryString = new URLSearchParams(search).toString();

      debounceTimeout.current = setTimeout(async () => {
        const response = await fetch(
          `${proxy()}/area/warehouse?${queryString}`,
          {
            method: "POST",
            headers: {
              "content-type": "application/json",
              Authorization: localStorage.getItem("_token"),
            },
            body: JSON.stringify({ search, areaId: area }),
          },
        );
        const result = await response.json();

        setSelectedValues((prev) => {
          const prevDeviceNames =
            (prev?.storages &&
              prev?.storages?.length &&
              prev?.storages?.map((item) => item?.["11MK"])) ||
            [];

          const filteredResult =
            result &&
            result.length &&
            result.filter((item) => prevDeviceNames?.includes(item?.["11MK"]));

            return {
            ...prev,
            searchStorages: filteredResult,
          };
        });
        // setSearch("");
        return;
        if (Object.values(search).length == 0) {
          setSelectedValues((prev) => ({
            ...prev,
            storages: views,
          }));
          return;
        }

        setSelectedValues((prev) => {
          const prevDeviceNames =
            (prev?.storages &&
              prev?.storages?.length &&
              prev?.storages?.map((item) => item.maKhoERPKho)) ||
            [];

          const filteredResult =
            result &&
            result.length &&
            result.filter((item) =>
              prevDeviceNames?.includes(item.maKhoERPKho),
            );
          return {
            ...prev,
            storages: filteredResult,
          };
        });
      }, 300);
    }
  }, [area, search]);
  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };
  console.log("SLEEEEEEEEE", selectedValues)
  return (
    <>
      <div
        style={{
          display: "grid",
          justifyItems: "center",
        }}
      >
        <Item
          label={"Nhóm quyền"}
          type={"option"}
          value={privilegeGroupsValue}
          k="privilegeGroup"
          // errorMessage={}
          options={privilegeGroups}
          handleChange={(val) => {
            onChange(val);
          }}
          col={7}
          required={true}
        />

        <div className="col-sm-7 mb-2">
          <label>Khu Vực</label>
          <div className="d-flex align-items-center">
            <AsyncPaginate
              className="w-100"
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              placeholder={lang["select value"]}
              loadOptions={async (search, loadedOptions, { page }) => {
                return await handleGetData(page, loadedOptions, search);
              }}
              components={{
                Option: CustomOption,
              }}
              isMulti
              onChange={(opts = []) => {
                const last = opts[opts.length - 1];

                const hasAll = opts.some((o) => o?.value === "all");
                const plants = hasAll ? dataArea : opts.length ? opts : [];

                setArea(plants.map(({ value }) => value));
                setSelectedValues((prev) => ({
                  ...prev,
                  plantsView: plants,
                }));
              }}
              options={[{ label: "Tất cả", value: "all" }]}
              value={selectedValues?.plantsView || []}
              isSearchable={true}
              styles={{
                control: (base) => ({
                  ...base,
                  maxHeight: "20vh",
                  overflow: "auto",
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "300px",
                  fontFamily: "UTM Avo , sans-serif !important",
                }),

                menu: (base) => ({
                  ...base,
                  zIndex: 99999,
                }),
              }}
              additional={{
                page: 0,
              }}
              allowCreateWhileLoading={false}
            />
            <div className="ml-3">
              <button
                className="btn btn-danger m-0"
                onClick={() => {
                  setSelectedValues((prev) => ({
                    ...prev,
                    storagesView: [],
                    plantsView: [],
                    // plants: [],
                  }));
                  setStorages([]);
                  setArea([]);
                }}
              >
                Xóa
              </button>
            </div>
          </div>
        </div>
        <Storages
          setSelectedValues={setSelectedValues}
          selectedValues={selectedValues}
          areaId={area}
          setArea={setArea}
          onChange={(payload = []) => {
            setSelectedValues((prev) => {
              const newPrev = { ...prev };
              if (newPrev.storages && newPrev.storages.length === 0) {
                return {
                  ...newPrev,
                  storages: payload,
                };
              }

              const newData = newPrev.storages.map((v) => {
                const found = payload.find((p) => p.value === v.value);
                return found ? { ...v, ...found } : v;
              });

              payload.forEach((p) => {
                if (!newData.some((v) => v.value === p.value)) {
                  newData.push(p);
                }
              });

              setViews(newData);
              return {
                ...newPrev,
                storages: newData,
              };
            });
            // setStorages((prev) => {
            //   const newStorages = [...prev];
            // const existingIds = new Set(
            //   prev.map((p) => p?.storage?.["11MK"])
            // );

            // const newStorages = [...prev];

            // payload.forEach(({ value: item }) => {
            //   const id = item?.["11MK"];
            //   if (id && !existingIds.has(id)) {
            //     existingIds.add(id);
            //     newStorages.push({ area, storage: item });
            //   }
            // });
            // console.log("newStorages", newStorages);
            // return newStorages;
            // });
          }}
          setStorages={setStorages}
        />
        <div className="col-sm-7 mt-3">
          <>
            <div
              className="table_permission"
              style={{
                height: storages.length > 5 ? "34vh" : "unset",
                overflow: "auto",
              }}
            >
              <table className="table table-custom">
                <thead>
                  <tr
                    style={{
                      position: "sticky",
                      top: "-1px",
                      zIndex: 1,
                    }}
                  >
                    <td className="align-center">Khu Vực</td>
                    <td className="align-center">Mã Kho Con</td>
                    <td className="align-center">Tên Kho</td>
                    <td className="align-center">Mã Tổ Chức Kho</td>
                    <td className="align-center" style={{ width: "1%" }}>
                      {lang["Actions"]}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style={{
                      position: "sticky",
                      top: "45px",
                      zIndex: 1,
                      background: "white",
                    }}
                  >
                    {["2TKV", "maKhoERPKho", "4TK", "8LK"].map(
                      (item, _indx) => (
                        <td key={_indx} className="align-center">
                          <input
                            type="text"
                            className="form-control"
                            onChange={(e) => {
                              const { value } = e.target;
                              setSearch((prev) => ({
                                ...prev,
                                [item]: value.trim(),
                              }));
                            }}
                          />
                        </td>
                      ),
                    )}
                    <td className="align-center">
                      <button
                        className="btn btn-danger m-0"
                        onClick={() => {
                          setSearch("");
                          setSelectedValues((prev) => ({
                            ...prev,
                            warehouses: [],
                            storages: [],
                            storagesView: [],
                          }));
                        }}
                      >
                        Xóa tất cả
                      </button>
                      {/* <div className="icon-table">
                        <div className="icon-table-line">
                          <FontAwesomeIcon
                            className="icon-delete pointer"
                            icon={faTrashCan}
                            onClick={() => {
                              setSelectedValues((prev) => ({
                                ...prev,
                                lines: [],
                              }));
                            }}
                          />
                        </div>
                      </div> */}
                    </td>
                  </tr>
                  {currentData && currentData.length > 0 ? (
                    currentData.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              whiteSpace: "pre",
                              maxWidth: "250px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={item?.KV?.["2TKV"]}
                          >
                            {item?.KV?.["2TKV"]}
                          </td>
                          <td>{item?.maKhoERPKho}</td>
                          <td>{item?.["4TK"]}</td>
                          <td>{item?.["8LK"]}</td>
                          <td className="align-center">
                            <div className="icon-table">
                              <div className="icon-table-line">
                                <FontAwesomeIcon
                                  className="icon-delete pointer"
                                  icon={faTrashCan}
                                  onClick={() => {
                                    handleDelete(item?.maKhoERPKho);
                                    setSearch("");
                                  }}
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="3" className="align-center">
                        {lang["not found data"]}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {currentData && currentData.length ? (
              <Pagination
                total={selectedValues?.searchStorages?.length || selectedValues?.storages?.length || 0}
                itemsPerPage={dataPerPage}
                currentPage={currentPage}
                paginate={paginate}
                lang={lang}
              />
            ) : null}
            <div className="d-flex flex-wrap justify-content-end">
              {isAdd && (
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    navigate("/users");
                  }}
                >
                  {lang["back"]}
                </button>
              )}
              <button
                className="btn btn-success btn-custom float-right ml-2"
                data-toggle="modal"
                // data-target="#modalConfirm"
                // data-backdrop="static"
                onClick={() => {
                  if (isAdd) {
                    setModalConfirm(false);
                    cb(tempUserInfor);
                  } else {
                    handleUpdate();
                  }
                }}
              >
                {isAdd ? lang["btn.update"] : lang["update"]}
              </button>
            </div>
          </>
        </div>
      </div>
      {isModalConfirm && (
        <div
          class="modal fade"
          id="modalConfirm"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">
                  {lang["profile user"]}
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div
                class="modal-body"
                style={{
                  height: "70vh",
                  overflow: "auto",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    justifyItems: "center",
                  }}
                >
                  <div className="col-sm-6">
                    <label className="form-label">{lang["username"]}:</label>
                    <input
                      className="form-control"
                      placeholder={tempUserInfor.username}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">{lang["fullname"]}:</label>
                    <input
                      className="form-control"
                      placeholder={tempUserInfor.fullname}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">{lang["phone"]}:</label>
                    <input
                      className="form-control"
                      placeholder={tempUserInfor.phone}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">{lang["address"]}:</label>
                    <input
                      className="form-control"
                      placeholder={tempUserInfor.address}
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">{lang["note"]}:</label>
                    <textarea
                      className="form-control"
                      placeholder={tempUserInfor.note}
                      readOnly
                    ></textarea>
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">
                      {lang["privilegegroup"]}:
                    </label>
                    <input
                      className="form-control"
                      placeholder={
                        privilegeGroups.find(
                          ({ value }) =>
                            value === tempUserInfor.privilegeGroup?.[0],
                        )?.label
                      }
                      readOnly
                    />
                  </div>
                  <div className="col-sm-6 mt-3">
                    <div
                      className="table_permission"
                      style={{
                        height: storages.length > 0 ? "20vh" : "unset",
                        overflow: "auto",
                      }}
                    >
                      <table className="table table-custom">
                        <thead
                          style={{
                            position: "sticky",
                            top: "-1px",
                          }}
                        >
                          <tr>
                            <td className="align-center">Khu Vực</td>
                            <td className="align-center">Tên Kho</td>
                          </tr>
                        </thead>
                        <tbody>
                          {views.length > 0 ? (
                            views.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {item?.storage?.KV?.["2TKV"] ||
                                      item?.["2TKV"]}
                                  </td>
                                  <td>{item?.storage?.["4TK"]}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="3" className="align-center">
                                {lang["not found data"]}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  {lang["btn.cancel"]}
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-custom"
                  onClick={
                    () => isAdd && cb(tempUserInfor)
                    // console.log("tempUserInfor", tempUserInfor)
                  }
                >
                  {lang["btn.update"]}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
